


























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { layout, reportsManagement } from '@/modules/shared/shared/store/namespaces';
import { IncidentsHistoryDatatableItem } from '@/modules/reports/management/domain/incidents-history-datatable.item';
import { HistoryState } from '@/modules/reports/management/domain/history.state';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import DownloadIncident from '@/modules/reports/management/components/DownloadIncidentReportModal.vue';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { ReportsManagementActions } from '@/modules/reports/management/store/reports-management.actions';
import { ReportsManagementGetters } from '@/modules/reports/management/store/reports-management.getters';

@Component({
    name: 'incidents-view',
    components: { DownloadIncident, SectionTitle },
})
export default class IncidentsView extends Vue {
    searchIncidents: string = '';
    limitIncidents: number = 20;
    pageIncidents: number = 1;
    itemsPerPageIncidents: number[] = [5, 10, 15, 20];
    headersIncidents: {}[] = [
        { text: 'Incidente', value: 'number', align: 'start', sortable: false },
        {
            text: 'Inicio',
            value: 'startDate',
            align: 'start',
            sortable: false,
        },
        { text: 'Fin', value: 'endDate', align: 'start', sortable: false },
        { text: 'Causa', value: 'cause', align: 'start', sortable: false },
        { text: 'Centro', value: 'location', align: 'start', sortable: false },
    ];

    incidentsOptions: any = {};

    isFetchingIncidents: boolean = false;

    async changeIncidentsDayco() {
        this.isFetchingIncidents = true;
        const failed = await this.fetchIncidents({
            limit: this.limitIncidents,
            start: this.pageIncidents,
        });
        if (failed) {
            failed.showError();
        }
        this.isFetchingIncidents = false;
    }

    async mounted() {
        this.changeTitle({ title: 'Interrupciones', route: ['Histórico'] });
        const failed = await this.fetchIncidents({
            limit: this.limitIncidents,
            start: this.pageIncidents,
        });
        if (failed) {
            (failed as ExceptionMessage).showError();
        }
    }

    @Watch('incidentsOptions.itemsPerPage')
    onItemsPerPageChangedOnIncidents(value) {
        this.limitIncidents = value;
        this.changeIncidentsDayco();
    }

    @layout.Mutation(LayoutMutations.CHANGE_TITLE) changeTitle!: (title: LayoutTitle) => void;

    @reportsManagement.Action(ReportsManagementActions.FETCH_HISTORY_INCIDENTS)
    fetchIncidents!: (options: { limit: number; start: number }) => Promise<RequestResponse>;

    @reportsManagement.Getter(ReportsManagementGetters.GET_HISTORY_INCIDENTS)
    incidents!: IncidentsHistoryDatatableItem[];

    @reportsManagement.Getter(ReportsManagementGetters.GET_HISTORY)
    historyOptions!: HistoryState;
}
